import React from 'react';
import './FooterRoutes.css'; // Make sure this file is in the same directory

const LegalPolicy = () => {
  return (
    <div className="container">
      <h1 className="title">Legal Policy</h1>
      <p>Thank you for choosing spectsgenie. This Legal Policy outlines the terms and conditions governing the use of our website and the legal responsibilities associated with your interactions with us. By accessing and using our website, you agree to comply with and be bound by the terms outlined in this policy.</p>

      <div className="section">
        <h2 className="subtitle">1. Terms of Service</h2>
        <p>- By using our website, you agree to abide by our Terms of Service, which govern the use of our website, services, and products. The Terms of Service can be found.</p>
      </div>

      <div className="section">
        <h2 className="subtitle">2. Privacy Policy</h2>
        <p>- Our Privacy Policy outlines how we collect, use, and protect your personal information. By using our website, you consent to the practices described in the Privacy Policy. The Privacy Policy can be found [provide link].</p>
      </div>

      <div className="section">
        <h2 className="subtitle">3. Refund Policy</h2>
        <p>- Our Refund Policy explains the conditions under which refunds may be requested. By making a purchase on our website, you agree to the terms outlined in the Refund Policy. The Refund Policy can be found [provide link].</p>
      </div>

      <div className="section">
        <h2 className="subtitle">4. Shipping Policy</h2>
        <p>- The Shipping Policy details the procedures and timelines for the delivery of our products. By placing an order with us, you agree to the terms and conditions outlined in the Shipping Policy. The Shipping Policy can be found [provide link].</p>
      </div>

      <div className="section">
        <h2 className="subtitle">5. Disclaimer</h2>
        <p>- Our Disclaimer sets forth the limitations of liability and disclaims warranties regarding the use of our website. By using our website, you acknowledge and agree to the terms outlined in the Disclaimer. The Disclaimer can be found [provide link].</p>
      </div>

      <div className="section">
        <h2 className="subtitle">6. Intellectual Property</h2>
        <p>- All content on our website, including but not limited to text, images, logos, and trademarks, is the intellectual property of spectsgenie. Unauthorized use of our intellectual property is strictly prohibited.</p>
      </div>

      <div className="section">
        <h2 className="subtitle">7. Governing Law and Jurisdiction</h2>
        <p>- This Legal Policy is governed by and construed in accordance with the laws of India. Any disputes arising out of or in connection with this Legal Policy shall be subject to the exclusive jurisdiction of the courts in Bangalore, Karnataka.</p>
      </div>

      <div className="section">
        <h2 className="subtitle">8. Changes to Legal Policy</h2>
        <p>- We reserve the right to make changes to this Legal Policy at any time without prior notice. It is your responsibility to review this policy periodically for any updates.</p>
      </div>

      <div className="section">
        <h2 className="subtitle">9. Contact Information</h2>
        <p>If you have any questions or concerns regarding this Legal Policy, please contact us at <a href="mailto:support@spectsgenie.com">support@spectsgenie.com</a>.</p>
      </div>

      <p>Note:</p>
      <ul>
        <li>- This Legal Policy is subject to change without notice. Please review this policy periodically for any updates.</li>
        <li>- By using our website, you agree to the terms and conditions outlined in this Legal Policy.</li>
      </ul>

      <p>Thank you for choosing spectsgenie. We appreciate your trust and aim to provide you with a positive and secure online shopping experience.</p>
    </div>
  );
};

export default LegalPolicy;
